import React from "react";
import { NavLink } from "react-router-dom";
import Tematicas from "../../commons/tematicas.module";
import "./vista-inicio-block-tematicas.block.scss";
const LISTA_TEMATICAS = Tematicas.getList();
class BlockTematicas extends React.Component {
  constructor(props) {
    super(props);
    let me = this;
    me.state = {
      active: ""
    };
    me.onImageMouseOver = me.onImageMouseOver.bind(me);
  }
  render() {
    let me = this;
    const { active } = this.state;
    return (
      <div className="vista-inicio__block-tematicas">
        <div className="vista-inicio__block__header">
          <i className="icon-tematica" />
          <span className="vista-inicio__block__header__text">
            Temática Ambiental
          </span>
        </div>
        <div className="vista-inicio__block__body">
          <div>
            {LISTA_TEMATICAS.map(tematica => {
              return (
                <NavLink
                  key={tematica.value}
                  to={`./tematicas?tematica=${tematica.value}`}
                >
                  <img
                    src={`imagenes/tematicas/${tematica.value}_${
                      active === tematica.value ? "azul" : "verde"
                    }.png`}
                    alt={tematica.label}
                    onMouseOver={() => me.onImageMouseOver(tematica.value)}
                    onMouseOut={() => me.onImageMouseOut(tematica.value)}
                  />
                </NavLink>
              );
            })}
          </div>
        </div>
        <div className="vista-inicio__block__footer">&nbsp;</div>
      </div>
    );
  }
  onImageMouseOver(idTematica) {
    this.setState({ active: idTematica });
  }
  onImageMouseOut() {
    this.setState({ active: "" });
  }
}
export default BlockTematicas;
